'use strict';

exports.__esModule = true;
exports.getValueByIdentifier = getValueByIdentifier;
exports.getValueByIdentifierFromContext = getValueByIdentifierFromContext;
exports.getMetaByIdentifier = getMetaByIdentifier;

var _isEmpty = require('../utils/is-empty');

var _validateTagStructure = require('../utils/validate-tag-structure');

var _TagSchemas = require('../../types/TagSchemas');

var _resolvePayload = require('../../renderer/resolvePayload');

var _fillInPatternBlob = require('../../patterns/fill-in-pattern-blob');

function getValueByIdentifier(tags, identifier) {
  var result = findTag(tags, identifier);
  return result ? getValueFromTag(result, identifier) : result;
}

function getValueByIdentifierFromContext(payload, identifier, context, referencePath) {
  var tags = (0, _resolvePayload.resolvePayload)(payload).tags;
  var result = findTag(tags, identifier);

  return result ? getValueFromTagUsingContext(result, identifier, context, tags, referencePath) : result;
}

function getMetaByIdentifier(tags, identifier) {
  var result = findTag(tags, identifier);
  return (result ? result.meta : null) || {};
}

function findTag(tags, identifier) {
  if (!tags || !identifier) {
    return null;
  }
  var tag = getTagByIdentifier(tags, identifier);
  if ((0, _isEmpty.isEmpty)(tag)) {
    return undefined;
  }
  return tag;
}

function getTagByIdentifier(tags, identifier) {
  var tagSchema = _TagSchemas.TAG_SCHEMAS[identifier];
  if ((0, _isEmpty.isEmpty)(tagSchema) || (0, _isEmpty.isEmpty)(tags)) {
    return {};
  }

  return tags.slice().reverse().find(function (tag) {
    return (0, _validateTagStructure.validateTagStructure)(tag, tagSchema);
  });
}

function getValueFromTagUsingContext(tag, identifier, context, tags, referencePath) {
  var tagSchema = identifier && _TagSchemas.TAG_SCHEMAS[identifier];

  if ((0, _isEmpty.isEmpty)(tag) || (0, _isEmpty.isEmpty)(tagSchema)) {
    return '';
  }

  var value = tagSchema.getValue(tag);
  if (value.search(/{{.+?}}/g) !== -1) {
    return (0, _fillInPatternBlob.fillPatternValue)(value, context, tags, referencePath);
  } else {
    return value === 'undefined' ? undefined : value;
  }
}

function getValueFromTag(tag, identifier) {
  var tagSchema = identifier && _TagSchemas.TAG_SCHEMAS[identifier];

  if ((0, _isEmpty.isEmpty)(tag) || (0, _isEmpty.isEmpty)(tagSchema)) {
    return '';
  }

  return tagSchema.getValue(tag);
}